// extracted by mini-css-extract-plugin
export default {"chats":"styles_chats__FG78y","desktopWrapper":"styles_desktopWrapper__RoHhJ"};